import { Slider } from 'antd'
import type { SliderSingleProps } from 'antd'

export type BasicSliderProps = SliderSingleProps

export const BasicSlider = (props: BasicSliderProps) => {
  return <Slider {...props} />
}
